import { isB2C } from '@/domains/core/settings/utils';
import { Accordion } from '@/domains/retention/Footer/modules/Accordion/Accordion';

import {
  footerContactTitle,
  footerNavigationAffiliation,
  footerNavigationAffiliationHref,
  footerNavigationContactUs,
  footerNavigationContactUsHref,
  footerNavigationCouponLegalMention,
  footerNavigationCouponLegalMentionHref,
  footerNavigationHelp,
  footerNavigationHelpHref,
  footerNavigationOrders,
  footerNavigationOrdersHref,
  footerNavigationRecruitingSellers,
  footerNavigationRecruitingSellersHref,
  footerNavigationRecruitment,
  footerNavigationRecruitmentHref,
  footerReportContentDSALabel,
  footerReportContentDSALink,
} from '../../translations';
import { NavigationLinks } from './NavigationLinks';

export const Navigation = () => {
  const links = [
    {
      label: footerNavigationOrders,
      link: footerNavigationOrdersHref,
      dataTestId: 'accountOrderCta',
    },
    {
      label: footerNavigationHelp,
      link: footerNavigationHelpHref,
      dataTestId: 'helpCta',
    },
    isB2C()
      ? {
          label: footerNavigationContactUs,
          link: footerNavigationContactUsHref,
          dataTestId: 'contactUsCta',
        }
      : undefined,
    {
      label: footerReportContentDSALabel,
      link: footerReportContentDSALink,
      dataTestId: 'reportContentDSA',
      target: '_blank',
      rel: 'noreferrer',
    },
    {
      label: footerNavigationRecruitingSellers,
      link: footerNavigationRecruitingSellersHref,
      dataTestId: 'recruitingSellerCta',
    },
    {
      label: footerNavigationRecruitment,
      link: footerNavigationRecruitmentHref,
      dataTestId: 'recruitingCta',
      rel: 'noopener',
    },
    {
      label: footerNavigationAffiliation,
      link: footerNavigationAffiliationHref,
      dataTestId: 'affiliateCta',
      rel: 'noopener',
    },
    isB2C()
      ? {
          label: footerNavigationCouponLegalMention,
          link: footerNavigationCouponLegalMentionHref,
          dataTestId: 'couponLegalMentionCta',
          target: '_blank',
          rel: 'noopener',
        }
      : undefined,
    // Boolean cannot be used to null check in this typescript version
    // Workaround: https://github.com/microsoft/TypeScript/pull/29955#issuecomment-1470876059
    // eslint-disable-next-line unicorn/prefer-native-coercion-functions
  ].filter((l): l is NonNullable<typeof l> => Boolean(l));

  return (
    <div
      className="mt-l border-t border-foundation-inverted pt-m desktop:mt-0
        desktop:border-t-0 desktop:pt-0"
    >
      <Accordion title={footerContactTitle}>
        <NavigationLinks links={links} />
      </Accordion>
    </div>
  );
};

Navigation.displayName = 'Navigation';
